// fernandojsg/aframe-teleport-controls
import './aframe-teleport-controls'
// matrix-org/aframe-look-at-component
import './look-at'
// mayognaise/aframe-gif-shader
import './aframe-gif-shader'
// ngokevin/kframe/tree/master/components/animation
import './aframe-animation-component'
// ngokevin/kframe/tree/master/components/animation-timeline
import './aframe-animation-timeline-component'



// Require all of your custom components
import './teleport-extras'
import './toggle-on-event'
import './lookatlabel'
import './ui-console'
import './checkpointspot'
import './video-controls'
import './panel'
import './panelbtn'
import './trunk'
/*

import './anchor-look'
*/



// WEBPACK FOOTER //
// ./src/aframe/components/index.js